
<template>
  <div class="secondClassify" :class="{ isIosx: isIosx, noAppNav: !isToken }">
    <van-sticky>
      <div class="secondClassifyNav">
        <img
          class="navLeft"
          @click="prev()"
          src="./../../assets/school/backh.png"
        />
        <span class="navTitle">{{ navTitle }}</span>
        <img
          v-if="isToken"
          class="navRight"
          @click="search()"
          src="./../../assets/school/seach2.png"
        />
      </div>
    </van-sticky>
    <div class="secondClassifyContent" v-if="!isNull">
      <van-tabs
        line-width="16px"
        line-height="4px"
        title-inactive-color="#6E727A"
        title-active-color="#404247"
        v-model="active"
        @change="tabChange"
        ref="tabs"
      >
        <van-tab
          v-for="(item, index) in navList"
          :key="index"
          :title="item.title"
        >
          <div class="contentTop">
            <div>
              <van-dropdown-menu active-color="#4E7DF7">
                <van-dropdown-item
                  :title="dropdownTitle1"
                  get-container="body"
                  ref="dropdown1"
                >
                  <ul class="dropdownMenu">
                    <li
                      class="dropdownItem"
                      :class="{ dropdownItemCheck: item.check }"
                      v-for="(item, index) in dropdownOption1"
                      :key="index"
                      @click="choice(1, item.value, item.text)"
                    >
                      {{ item.text }}
                    </li>
                  </ul>
                </van-dropdown-item>
                <!-- <van-dropdown-item
                  :title="dropdownTitle2"
                  get-container="body"
                  ref="dropdown2"
                >
                  <ul class="dropdownMenu">
                    <li
                      class="dropdownItem"
                      :class="{ dropdownItemCheck: item.check }"
                      v-for="(item, index) in dropdownOption2"
                      :key="index"
                      @click="choice(2, item.value, item.text)"
                    >
                      {{ item.text }}
                    </li>
                  </ul>
                </van-dropdown-item> -->
              </van-dropdown-menu>
            </div>
            <span @click="changeShowType()">
              <img src="./../../assets/school/morerow.png" v-if="showType" />
              <img src="./../../assets/school/singlerow.png" v-else />
            </span>
          </div>
          <div class="secondClassifyMid" v-if="loaded">
            <div v-if="dataList.length > 0">
              <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                <van-list
                  v-model="loading"
                  :finished="finished"
                  finished-text="没有更多了"
                  @load="onLoad"
                >
                  <CourseColum
                    :dataList="dataList"
                    v-if="showType"
                  ></CourseColum>
                  <CourseRow :dataList="dataList" v-else></CourseRow>
                </van-list>
              </van-pull-refresh>
            </div>
            <div v-else class="noData">
              <img src="./../../assets/school/404.png" />
              <p>没有找到相关课程～</p>
            </div>
          </div>
          <div v-else class="load">
            <img src="./../../assets/school/loading.gif" />
            <p>加载中</p>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <div class="noData" v-else>
      <img src="./../../assets/school/404.png" />
      <p>没有找到相关课程～</p>
    </div>
  </div>
</template>

<script>
import CourseColum from "./components/courseColumn.vue";
import CourseRow from "./components/courseRow.vue";
export default {
  data() {
    return {
      navTitle: "",
      loaded: false,
      navList: [],
      activeId: 0,
      active: 0,
      type: 0,
      cost_type: 0,
      isIosx: false,
      showType: true, //展示类型true一列，false两列
      dropdownOption1: [
        { text: "全部", value: 0, check: true },
        { text: "图文", value: 3, check: false },
        { text: "视频", value: 2, check: false },
        { text: "音频", value: 4, check: false },
        { text: "专栏", value: 1, check: false },
      ],
      dropdownTitle1: "课程分类",
      dropdownOption2: [
        { text: "全部", value: 0, check: true },
        { text: "免费", value: 1, check: false },
        { text: "不免费", value: -1, check: false },
      ],
      dropdownTitle2: "收费类型",
      dataList: [],
      secondClassifylUrl: "school/index/courses",
      isToken: false,
      isNull: true, //是否存在三级
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      pageSize: 10,
      isHome: false, //是否从首页进来
      secondId: 0, //二级分类id
    };
  },
  components: { CourseColum, CourseRow },
  mounted() {
    this.isIosx = this.isIphoneX();
    if (JSON.parse(sessionStorage.getItem("token"))) {
      this.isToken = true;
      this.secondClassifylUrl = "school/member/courses";
      this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    } else {
      this.isToken = false;
      this.secondClassifylUrl = "school/index/courses";
    }
    if (this.$route.query.secondId) {
      this.secondId = this.$route.query.secondId;
    }
    if (this.$route.query.isHome) {
      this.isHome = this.$route.query.isHome;
      if (this.isHome) {
        // 获取三级分类
        this.getThree();
      }
    }
    if (this.$route.query.title) {
      this.navTitle = this.$route.query.title;
    }
    if (this.$route.query.navList) {
      this.navList = JSON.parse(this.$route.query.navList);
    }
    if (this.$route.query.activeId) {
      this.activeId = this.$route.query.activeId;
      if (this.activeId == -1) {
        this.isNull = true;
      } else {
        this.isNull = false;
        if (this.activeId == -2) {
          this.active = 0;
          this.activeId = this.navList[0].id;
        } else {
          this.navList.forEach((item, index) => {
            if (item.id == this.activeId) {
              this.active = index;
            }
          });
        }
        this.getData();
      }
    }
  },
  methods: {
    // 返回
    prev() {
      this.$router.go(-1);
    },
    // tab切换
    tabChange(name, title) {
      this.activeId = this.navList[name].id;
      this.page = 0;
      this.dataList = [];
      this.onLoad();
      this.loaded = false;
    },
    // 展示类型切换
    changeShowType() {
      this.showType = !this.showType;
    },
    // 下拉筛选选择
    choice(type, value, title) {
      if (type == 1) {
        this.dropdownOption1.forEach((item) => {
          item.check = false;
          if (item.value == value) {
            item.check = true;
          }
        });
        this.type = value;
        this.dropdownTitle1 = title == "全部" ? "课程分类" : title;
        this.$refs.dropdown1.forEach((item) => {
          item.toggle(false);
        });
      } else if (type == 2) {
        this.dropdownOption2.forEach((item) => {
          item.check = false;
          if (item.value == value) {
            item.check = true;
          }
        });
        this.cost_type = value;
        this.dropdownTitle2 = title == "全部" ? "收费类型" : title;
        this.$refs.dropdown2.forEach((item) => {
          item.toggle(false);
        });
      }
      this.page = 0;
      this.dataList = [];
      this.onLoad();
    },
    // 获取三级分类
    getThree() {
      this.$api
        .get("school/index/sub/categories", {
          parent_id: this.secondId,
        })
        .then((res) => {
          this.navList = res.list;
          this.navList.forEach((item, index) => {
            if (item.id == this.activeId) {
              this.active = index;
            }
          });
        });
    },
    // 获取数据
    getData() {
      this.$api
        .get(this.secondClassifylUrl, {
          api_category_id: this.activeId, //分类id
          type: this.type, //1专栏 ，2:单视频，3图文，4音频
          cost_type: this.cost_type, //1:免费，-1不免费
          page: this.page,
          pageSize: this.pageSize,
          // title: '', //标题
        })
        .then((res) => {
          this.dataList = this.dataList.concat(res.list);
          this.loaded = true;
          this.refreshing = false;
          this.loading = false;
          if (this.dataList.length >= res.total) {
            // 数据全部加载完成
            this.finished = true;
          } else {
            this.finished = false;
          }
        });
    },
    // 下拉刷新
    onRefresh() {
      this.page = 1;
      this.dataList = [];
      this.getData();
    },
    // 上拉加载
    onLoad() {
      this.page++;
      this.getData();
    },
    // 搜索
    search() {
      this.$router.push({
        path: "/school/search",
      });
    },
  },
};
</script>

<style>
.load {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.load img {
  width: 80px;
  height: 80px;
  margin: 200px 0 0;
}
.load p {
  font-size: 12px;
  color: #9ca1ad;
}
.secondClassify {
  height: 100%;
  /* overflow: auto; */
}
.secondClassifyNav {
  color: #404247;
  height: 22px;
  padding-top: 38px;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 11px;
  background-color: #ffffff;
  position: relative;
}
.secondClassifyNav .navLeft {
  position: absolute;
  left: 16px;
  width: 24px;
  height: 24px;
}
.secondClassifyNav .navTitle {
  font-size: 17px;
  font-weight: bold;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.secondClassifyNav .navRight {
  position: absolute;
  right: 16px;
  width: 24px;
  height: 24px;
}
/* content */
.secondClassifyContent {
  margin: 0 16px;
}
/* .secondClassify .van-tabs__wrap {
  margin: 0 16px;
} */
.secondClassify .van-tabs__line {
  background: linear-gradient(90deg, #4e7df7 0%, #86b4fc 100%);
  bottom: 19px;
}
.secondClassifyContent .van-tab {
  flex: none;
  margin-right: 24px;
  padding: 0;
  font-size: 15px;
}
.secondClassifyContent .van-tab--active {
  font-weight: 700;
}
.contentTop {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}
.contentTop > div {
  width: 100px;
}
.contentTop .van-dropdown-menu__bar {
  height: 26px;
  box-shadow: none;
}
.contentTop .van-dropdown-menu__item {
  background-color: #f7f8fc;
  margin-right: 16px;
  border-radius: 20px;
}
.contentTop .van-dropdown-menu__item:last-child {
  margin: 0;
}
.contentTop .van-dropdown-menu__title {
  font-size: 13px;
  color: #9ca1ad;
  margin-left: -7px;
}
.contentTop > span img {
  width: 16px;
  height: 16px;
}
/* 自定义下拉菜单 */
.dropdownMenu {
  color: #404247;
  font-size: 13px;
  padding: 24px 32px 0;
}
.dropdownItem {
  margin-bottom: 24px;
}
.dropdownItemCheck {
  color: #4e7df7;
}

.secondClassifyMid {
  margin-top: 24px;
}

.isIosx .secondClassifyNav {
  padding-top: 44px;
}
.noAppNav .secondClassifyNav {
  padding-top: 15px !important;
}

/* 没有数据 */
.noData {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.noData img {
  width: 235px;
  height: 235px;
}
.noData p {
  font-size: 14px;
  color: #9ca1ad;
  margin-top: 24px;
}
</style>